import { useLocalStorage } from "usehooks-ts";
import Constants from "./constants";
import { AppState } from "../contexts/app/reducer";

export const useIsUserInSandbox = (
  state: AppState
): { isSandboxMap: { [key: string]: boolean }; userIsSandbox: boolean } => {
  const username = state.user?.username || "";

  const [isSandbox] = useLocalStorage<{ [key: string]: boolean }>(Constants.isSandboxKey, {
    [username]: false,
  });

  const userIsSandbox = isSandbox[username];

  return {
    isSandboxMap: isSandbox,
    userIsSandbox,
  };
};
